import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, InputNumberField, DateField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import styles from './PartnersOfficersEmployersComponent.module.scss';
import metadata from './PartnersOfficersEmployersComponent.metadata.json5';
import { TranslatorContext } from '@jutro/legacy/locale';

function PartnersOfficersEmployersComponent(props) {

    const {
        data: PartnersOfficersEmployersVM,
        updateWizardData,
        submissionVM,
        PartnersOfficersEmployersPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);


    const addPartnersOfficersEmployers = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            PartnersOfficersEmployersVM.value = PartnersOfficersEmployersVM.value || []

            const { _xCenter, _dtoName } = PartnersOfficersEmployersVM;

            const PartnersOfficersEmployersObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            PartnersOfficersEmployersVM.pushElement(
                PartnersOfficersEmployersObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, PartnersOfficersEmployersVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            PartnersOfficersEmployersVM.value.splice(index, 1);
            _.set(submissionVM.value, PartnersOfficersEmployersPath, PartnersOfficersEmployersVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, PartnersOfficersEmployersPath, PartnersOfficersEmployersVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;


            if (path === 'nam1') {
                const value = item.nam1 ? item.nam1 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.nam1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'yeaInPos2') {
                const value = item.yeaInPos2 ?? '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.yeaInPos2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                        maxValue={999999}
                    />
                );
            }

            if (path === 'degQua3') {
                const value = item.degQua3 ? item.degQua3 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.degQua3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'yeaOfProExp4') {
                const value = item.yeaOfProExp4 ?? '';;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.yeaOfProExp4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                        maxValue={999999}
                    />
                );
            }
        }, [handleValueChange, PartnersOfficersEmployersVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`PartnersOfficersEmployersTable`]: {
            data: PartnersOfficersEmployersVM.value,
        }

    }), [PartnersOfficersEmployersVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addPartnersOfficersEmployers,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            PartnersOfficersEmployersVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [PartnersOfficersEmployersVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={PartnersOfficersEmployersVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

PartnersOfficersEmployersComponent.propTypes = wizardProps;
export default withRouter(PartnersOfficersEmployersComponent);
